/* eslint-disable prefer-destructuring */
export const letters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const getNextLetter = (letter: string): string => letters[letters.indexOf(letter) + 1] || 'A';

/**
 * Get a number and letter
 */
export const getExerciseNumber = (exercise: any) => {
  if (!exercise) return { letter: '', number: '' };

  const name = (exercise.order_name || '').toString(); // '1A'

  // old format starts with 'A, B1..'
  if (name.match(/^[A-Z]/i)) {
    const regexp = /^([a-z]{1,2})(\d{0,2})$/i;
    const match = name.match(regexp) || []; // 'A1' => ['A1', 'A', '1']
    const letter = match[2] ? letters[Number(match[2]) - 1] : '';
    const number = letters.indexOf(match[1] || name) + 1;

    return {
      letter,
      number,
      order_name: `${number}${letter}`,
    };
  }

  const regexp = /^(\d{0,2})([a-z]{1,2})?$/i;
  const match = name.match(regexp) || []; // '1A' => ['1A', '1', 'A']

  return {
    letter: match[2] || '',
    number: Number(match[1]),
  };
};

export const getExerciseLetter = (exercise: any) => {
  if (!exercise) return { letter: '', numeric: '' };

  const regexp = /^([a-z]{1,2})(\d{0,2})$/i;
  const value = (exercise.order_name || '').toString(); // 'A1'

  const match = value.match(regexp) || []; // 'A1' => ['A1', 'A', '1']
  const letter = match[1] || value;
  const numeric = match[2] ? Number(match[2]) : '';

  return {
    letter,
    numeric,
  };
};

export const updateOrderNameExercises = (exercises: any[]) => {
  let alternatives: any[] = [];
  const newList = exercises.reduce(
    (accumulator, item, currentIndex) => {
      const before = exercises[currentIndex - 1];
      const after = exercises[currentIndex + 1];
      const lastUpdated = accumulator[accumulator.length - 1];
      const position = currentIndex + 1;

      let number = lastUpdated ? lastUpdated.number + 1 : 1;
      let letter = '';

      if (item.number === after?.number) {
        letter = 'A';
      }

      if (item.number === before?.number) {
        letter = getNextLetter(lastUpdated.letter);
        number = lastUpdated.number;
      }

      if (item.alternatives.length > 0) {
        alternatives = alternatives.concat(
          item.alternatives.map(
            (a: any) => ({
              ...a,
              letter,
              number,
              order_name: `${number}${letter}`,
            }),
          ),
        );
      }

      return [
        ...accumulator,
        {
          ...item,
          letter,
          number,
          position,
          order_name: `${number}${letter}`,
        },
      ];
    },
    [],
  );

  const updated = newList.filter((exercise: any) => {
    const old = exercises.find((e: any) => e.id === exercise.id);
    return exercise.order_name !== old.order_name || exercise.position !== old.position;
  });

  return [
    ...updated,
    ...alternatives,
  ];
};
